import { handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import type { QcsSyncResourceStoreProps } from '../core/resourceStoreTypes';
import * as actions from './termsActions';
import { mkTermsStore, type TermProps, type TermsStore } from './termsTypes';

const reducer = handleActions<
  TermsStore,
  | ReturnType<typeof actions.getTerms>
  | ReturnType<typeof actions.getTermsSuccess>
  | ReturnType<typeof actions.getTermsFailure>
  | ReturnType<typeof actions.createTerm>
  | ReturnType<typeof actions.createTermSuccess>
  | ReturnType<typeof actions.deleteTerm>
  | ReturnType<typeof actions.deleteTermSuccess>
>(
  {
    [actions.getTerms.type]: (state) => state.merge({ isLoading: true, error: undefined }),
    [actions.getTermsSuccess.type]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getTermsFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError<TermProps, QcsSyncResourceStoreProps<TermProps>>(state, error),

    [actions.createTerm.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.createTermSuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),

    [actions.deleteTerm.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
    [actions.deleteTermSuccess.type]: (state, { payload }) => resourceUpserters.upsertResource(state, payload),
  },
  mkTermsStore(),
);

export default reducer;
